import { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * QuoteCarousel - Rotating quotes with navigation
 * 
 * Usage:
 * <QuoteCarousel quotes={[{ text: "Quote text", author: "Author Name" }]} />
 */
const QuoteCarousel = ({ quotes }) => {
  const [currentQuote, setCurrentQuote] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [quotes.length]);

  return (
    <section className="pt-4 pb-10 bg-gray-50 border-b border-gray-100" data-testid="quote-section">
      <div className="max-w-2xl mx-auto px-4">
        <div className="flex items-center justify-between h-[80px]">
          <button 
            onClick={() => setCurrentQuote((prev) => (prev - 1 + quotes.length) % quotes.length)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            data-testid="quote-prev"
          >
            <ArrowRight size={16} className="rotate-180 text-gray-400" />
          </button>
          
          <div className="text-center flex-1 px-6 flex flex-col justify-center h-full">
            <blockquote className="text-base font-light italic text-gray-500 mb-1" data-testid="quote-text">
              "{quotes[currentQuote].text}"
            </blockquote>
            <p className="text-xs text-gray-400 tracking-wider" data-testid="quote-author">— {quotes[currentQuote].author}</p>
          </div>
          
          <button 
            onClick={() => setCurrentQuote((prev) => (prev + 1) % quotes.length)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            data-testid="quote-next"
          >
            <ArrowRight size={16} className="text-gray-400" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default QuoteCarousel;
